import { ListItemButtonProps, ListItemButton as MuiListItemButton } from "@mui/material";
import { Link, LinkProps } from "@tanstack/react-router";

type Props = ListItemButtonProps;

export const ListItemButton = ({ children, ...props }: Props) => {
  return <MuiListItemButton {...props}>{children}</MuiListItemButton>;
};

export function AnyComponentListItemButton<C extends React.ElementType>({ children, ...props }: ListItemButtonProps<C, { component?: C }>) {
  return <MuiListItemButton {...props}>{children}</MuiListItemButton>;
}

export type RouterListItemButtonProps = LinkProps & ListItemButtonProps;

export const RouterListItemButton = ({ children, ...props }: RouterListItemButtonProps) => {
  return (
    <MuiListItemButton component={Link} {...props}>
      {children}
    </MuiListItemButton>
  );
};
